import { Selector } from '@ngxs/store';
import { ImageState } from './image.state';
import { ImageStateModel } from './image-state.model';
import { Image } from '@app/entities/images/interfaces/image';
import { ImageDetail } from '@app/entities/images/interfaces/image-details';
import { ImageTag } from '@app/entities/images/interfaces/image-tag';
import { ImagePreview } from '@app/entities/images/interfaces/image-preview';
import { ImageMeta } from '@app/entities/images/interfaces/image-meta';

export class ImageSelectors {
  @Selector([ImageState])
  static image(state: ImageStateModel): Image | undefined {
    return state.image;
  }

  @Selector([ImageState])
  static imageId(state: ImageStateModel): number | undefined {
    return state.image?.id;
  }

  @Selector([ImageState])
  static imageName(state: ImageStateModel): string | undefined {
    return state.image?.name;
  }

  @Selector([ImageState])
  static imageDescription(state: ImageStateModel): string | undefined {
    return state.image?.description;
  }

  @Selector([ImageState])
  static imageViews(state: ImageStateModel): number | undefined {
    return state.image?.views;
  }

  @Selector([ImageState])
  static imageDownloads(state: ImageStateModel): number | undefined {
    return state.image?.downloads;
  }

  @Selector([ImageState])
  static imageDetails(state: ImageStateModel): ImageDetail[] | undefined {
    return state.image?.details;
  }

  @Selector([ImageState])
  static isFavorite(state: ImageStateModel): boolean | undefined {
    return state.image?.is_favorite;
  }

  @Selector([ImageState])
  static imageTags(state: ImageStateModel): ImageTag[] | undefined {
    return state.image?.tags;
  }

  @Selector([ImageState])
  static imageLocation(state: ImageStateModel): string | undefined {
    return state.image?.location;
  }

  @Selector([ImageState])
  static imageLicense(state: ImageStateModel): string | undefined {
    return state.image?.license;
  }

  @Selector([ImageState])
  static imageCamera(state: ImageStateModel): string | undefined {
    return state.image?.camera;
  }

  @Selector([ImageState])
  static relatedImages(state: ImageStateModel): ImagePreview[] | undefined {
    return state.relatedImages;
  }

  @Selector([ImageState])
  static hasMoreResults(state: ImageStateModel): boolean {
    return (state?.relatedImages?.length || 0) < (state?.totalCount || 0);
  }

  @Selector([ImageState])
  static duration(state: ImageStateModel): number | undefined {
    return state.image?.duration;
  }

  @Selector([ImageState])
  static fps(state: ImageStateModel): string | undefined {
    return state.image?.fps;
  }

  @Selector([ImageState])
  static codecName(state: ImageStateModel): string | undefined {
    return state.image?.codec_name;
  }

  @Selector([ImageState])
  static bitRate(state: ImageStateModel): number | undefined {
    return state.image?.bit_rate;
  }
}
